import React, { useState } from "react";
import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/apiConfig";
import { showToast } from "./ToastNotification";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Register.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import signUp from "./../assets/images/SignUp.jpg";

const Register = () => {
    const navigate = useNavigate(); // Initialize useNavigate
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
    });

    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axiosInstance.post(API_ENDPOINTS.REGISTER, formData);
            showToast("Registration successful!", "success");
            navigate("/login"); // Redirect to login page
        } catch (error) {
            console.log("catch block ");
            const errorMessage = error.response?.data?.message || "Something went wrong.";
            showToast(errorMessage, "error");
        }
    };

    return (
        <div className="container" style={{ marginTop: "4rem" }}>
            <div className="row">
                {/* Left Side - Branding Section */}
                <div className="col-md-6 left-section">
                    <img src={signUp} alt="Digital Product" className="responsive-image" />
                </div>


                {/* Right Side - Registration Form */}
                <div className="col-md-6 right-section">
                    <div className="form-box">
                        <h2>Registration</h2>
                        <p className="form-subtext">Enter your details to register</p>

                        <form onSubmit={handleSubmit}>
                            <input type="text" name="firstName" placeholder="First Name" className="form-control mb-2" onChange={handleChange} required />
                            <input type="text" name="lastName" placeholder="Last Name" className="form-control mb-2" onChange={handleChange} required />
                            <input type="email" name="email" placeholder="Email" className="form-control mb-2" onChange={handleChange} required />

                            {/* Password Field with Eye Icon */}
                            <div className="password-container position-relative">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="Password"
                                    className="form-control mb-2"
                                    onChange={handleChange}
                                    required
                                />
                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="password-toggle-icon"
                                    style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#666",
                                    }}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>

                            {/* <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id="terms" required />
                                <label className="form-check-label" htmlFor="terms">
                                    I agree to the <a href="/terms">terms and conditions</a>
                                </label>
                            </div> */}

                            <button type="submit" className="btn btn-primary w-100">Sign Up</button>
                        </form>

                        <p className="login-link">
                            Already have an account?  
                            <Link to="/login">
                                Login here
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;
